import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app-state/store';
import { getFilters } from '../../../../canopy-ui-components/api/filters';
import Filters from '../../../../canopy-ui-components/components/Filters/SimpleFilters';

function SimpleFilters({
    layoutState,
    setLayoutState,
    dataKey,
    filterApi,
    globalProps,
    selectedGroupBy,
    selectedGroupByFilters,
    setSelectedGroupBy,
    setSelectedGroupByFilters,
    setGroupBy,
    setGroupByFilters,
    groupBy,
    groupByFilters,
    setUserId,
    userId,
    pageLayoutState,
}: any) {
    const { user: loggedInUser, switchUser } = useSelector(
        (state: RootState) => state.auth
    );
    const [currentUser, setCurrentUser] = useState<Record<
        string,
        any
    > | null>();
    const onApplyFilter = (
        filters: string[][] = [],
        groupBy: string[] = ['select-one']
    ) => {
        setSelectedGroupBy(groupBy);
        setSelectedGroupByFilters([...filters]);

        const otherFilters = pageLayoutState?.filter_options?.reduce(
            (acc: any, item: any) => {
                if (item !== groupBy[0]) {
                    acc[item] = null;
                }
                return acc;
            },
            {}
        );

        setLayoutState((layoutState: any) => {
            return {
                ...layoutState,
                ...otherFilters,
                [groupBy[0]]:
                    groupByFilters?.[groupBy[0]]?.length !== filters[0]?.length
                        ? escape(JSON.stringify(filters[0]))
                        : '',
            };
        });
    };

    useEffect(() => {
        (async () => {
            try {
                if (!layoutState?.user_id && !currentUser?.id) {
                    return;
                }
                if (layoutState?.user_id && layoutState?.user_id === userId) {
                    return;
                }
                if (currentUser?.id && currentUser?.id === userId) {
                    return;
                }

                const newUserId = layoutState?.user_id || currentUser?.id;
                const params: any =
                    layoutState?.user_id !== 'all' && layoutState?.user_id
                        ? {
                              parent_user_ids: String(layoutState?.user_id),
                          }
                        : {};
                if (!layoutState?.user_id) {
                    params.is_partner_document = true;
                }
                let filters: any = await getFilters(filterApi, {
                    ...params,
                });
                if (pageLayoutState?.filter_options) {
                    const fileType: any = filters['file_type'] || [];
                    if (fileType) {
                        filters['file_type'] = filters['file_type'].filter(
                            (types: any) => {
                                return fileType.push(types);
                            }
                        );
                    }
                }
                setGroupBy(
                    Object.keys(filters)?.filter((item) =>
                        pageLayoutState?.filter_options?.includes(item)
                    )
                );
                setSelectedGroupBy(['tag_value']);
                let transformedFilters: Record<
                    string,
                    Record<string, string>[]
                > = {};
                for (let key in filters) {
                    if (pageLayoutState?.filter_options?.includes(key)) {
                        transformedFilters[key] = filters[key].map(
                            (value: string) => {
                                return {
                                    label: value,
                                    value,
                                };
                            }
                        );
                    }
                }

                setGroupByFilters(transformedFilters);
                setSelectedGroupByFilters([[...filters['tag_value']]]);
                setUserId(newUserId);
                if (!globalProps?.qp?.group_by) {
                    setLayoutState((layoutState: any) => {
                        return {
                            ...layoutState,
                            group_by: 'tag_value',
                            group_by_filters: '',
                        };
                    });
                }
            } catch (e) {
                console.log(e);
            }
        })();
    }, [layoutState?.user_id, currentUser]);

    useEffect(() => {
        if (
            loggedInUser?.role === 'Partneradmin' ||
            loggedInUser?.role === 'RelationshipManager'
        ) {
            setCurrentUser(loggedInUser);
        } else if (
            switchUser?.role === 'Partneradmin' ||
            switchUser?.role === 'RelationshipManager'
        ) {
            setCurrentUser(switchUser);
        }
    }, [loggedInUser, switchUser]);
    return (
        <Filters
            globalProps={globalProps}
            groupByFilters={groupByFilters}
            selectedGroupByFilters={selectedGroupByFilters}
            groupBy={groupBy}
            selectedGroupBy={selectedGroupBy}
            allowMultipleFilters={false}
            onApply={onApplyFilter}></Filters>
    );
}
export default SimpleFilters;
